// @ts-nocheck
/*
 * Port of views/dashboard/module/add.js (origin/main-dev, 154 lines).
 * BYTE-IDENTICAL â€” status field commented-out in payload preserved
 * verbatim. Chrome swap: v1 <Card> â†’ shadcn.
 */
import { useState, useEffect } from 'react';
import { postApiCall } from '@/service/httpCall';
import { API_MODULE_CREATE } from '@/service/url';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/utilities/constant';
import { useAuth, errorCheck } from '@/views/dashboard/auth/auth-utils';
import RenderModuleForm from '@/features/module/ModuleForm';
import { toast } from 'sonner';
import { friendlyApiError } from '@/utilities/apiErrorMessage';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ScrollPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { ArrowLeft, Loader2, Save } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ModuleCreate() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [moduleName, setModuleName] = useState('');
  const [status, setStatus] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast);
  }, []);

  function validateForm() {
    let valid = true;
    if (!moduleName.trim()) {
      valid = false;
      toast.error('Module Name required');
    }
    return valid;
  }

  async function submitForm(e) {
    e.preventDefault();
    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    const params = {
      module_name: moduleName,
      // status:status
    };

    postApiCall(API_MODULE_CREATE, params)
      .then(onModuleCreateSuccess)
      .catch(onModuleCreateError);
  }

  function onModuleCreateSuccess() {
    toast.success('Module created successfully');
    setTimeout(() => {
      navigate(`/${ROUTES.MODULE.LIST}`);
    }, 1500);
  }

  function onModuleCreateError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      toast.error(friendlyApiError(err));
    }
  }

  return (
    <ScrollPage>
      <PageHeader
        title="New Module"
        description="Add a module to the ACL master list."
        actions={
          <Button asChild variant="outline">
            <Link to={`/${ROUTES.MODULE.LIST}`}>
              <ArrowLeft className="h-4 w-4" />
              Back
            </Link>
          </Button>
        }
      />
      <Card className="p-4">
        <form
          onSubmit={async (e) => {
            submitForm(e);
          }}
        >
          <RenderModuleForm moduleName={moduleName} setModuleName={setModuleName} />

          <div className="mt-4 flex items-center justify-end gap-2">
            <Button asChild variant="ghost">
              <Link to={`/${ROUTES.MODULE.LIST}`}>Cancel</Link>
            </Button>
            <Button type="submit" disabled={buttonDisable}>
              {buttonDisable ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <Save className="h-4 w-4" />
              )}
              {buttonDisable ? 'Adding…' : 'Add module'}
            </Button>
          </div>
        </form>
      </Card>
    </ScrollPage>
  );
}
